import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="border-t bg-background">
      <div className="mx-auto grid max-w-6xl gap-6 px-4 py-10 sm:px-6 md:grid-cols-3">
        <div className="space-y-2">
          <div className="font-display text-base font-semibold tracking-tight">
            33n Numeroloji
          </div>
          <p className="text-sm text-muted-foreground">
            Numeroloji raporu; kişisel farkındalık, ilişki dinamikleri ve karar
            süreçlerinde yol göstermek için hazırlanır.
          </p>
        </div>

        <div className="space-y-2 text-sm">
          <div className="font-medium">Hızlı Linkler</div>
          <div className="grid gap-2 text-muted-foreground">
            <a className="hover:text-foreground" href="#nasil-calisir">
              Nasıl çalışır?
            </a>
            <a className="hover:text-foreground" href="#paketler">
              Paketler
            </a>
            <a className="hover:text-foreground" href="#sss">
              SSS
            </a>
          </div>
        </div>

        <div className="space-y-2 text-sm">
          <div className="font-medium">İletişim</div>
          <p className="text-muted-foreground">
            Satın alma sonrası formu doldurursunuz; raporunuz PDF olarak e-posta
            ile teslim edilir.
          </p>
        </div>
      </div>

      <div className="border-t">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 text-xs text-muted-foreground sm:px-6">
          <span>© {new Date().getFullYear()} 33n</span>
          <span>Güvenli ödeme • PDF teslim</span>
        </div>
      </div>
    </footer>
  );
}
